// extracted by mini-css-extract-plugin
export default {"cls1":"NewsHeader-cls1_dOI","cls2":"NewsHeader-cls2__ua NewsHeader-cls1_dOI"};